<template>
  <div class="manual">
    <div style="padding: 2px 0; background: #E5E5E5"></div>
    <div class="manual__info">
      <div class="q-pb-sm" style="font-size:16px">
        <span class="text-black text-weight-bold text-capitalize">{{ ticket.name}}</span>
        <div>
          <span>{{ ticket.document_type }}:&nbsp;</span>
          <span>{{ ticket.document_number }}</span>
        </div>
        <span>Poltrona: {{ticket.seat}}</span>
      </div>
      <q-separator></q-separator>
      <div>
        <div class="row items-center q-py-sm">
          <i class="ri-bus-2-line q-pr-sm" style="font-size: 25px; color: #808285"></i>
          <span class="text-black text-weight-bold">CARRO {{ticket.number_bus}}</span>
        </div>
        <div class="row items-center q-pl-xs">
          <div
            style="width: 10px; height: 10px; background: #616264; border-radius:100%"
            class="shadow-2"
          ></div>
          <span class="q-pl-sm" style="color: #707070">{{ cityToCamelCase(ticket.origin) }}</span>
        </div>
        <div class="row items-center q-pl-xs q-pb-xs">
          <div
            style="width: 10px; height: 10px; background: #20C600; border-radius:100%"
            class="shadow-2"
          ></div>
          <span
            class="q-pl-sm text-weight-bold"
            style="color: #000000"
          >{{ cityToCamelCase(ticket.destiny) }}</span>
        </div>

        <div style="font-size: 13px; color: #7A8583; padding-left: 5px">
          <span>Saída dia&nbsp;</span>
          <span class="departure--semi-bold">{{ ticket.departure_travel | formatDate }}</span>
        </div>
        <div style="font-size: 13px; color: #7A8583; padding-left: 5px">
          <span>Saída da agência&nbsp;</span>
          <span class="departure--semi-bold">{{ ticket.departure | formatDate }}</span>
        </div>
      </div>
    </div>

    <div class="luggage">
      <q-list v-for="(b, index) in ticket.luggages" :key="index" class="q-pb-sm">
        <q-card class="luggage__grid items-center no-shadow" style="border-radius: 10px">
          <div>
            <i class="ri-suitcase-3-line" style="color: #004923; font-size: 28px"></i>
          </div>
          <div class="column" style="line-height: 1.2">
            <span style="color:#7A8583">Bagagem</span>
            <span style="color: #DA2128">
              <span class="text-weight-bold">ETIQUETA</span>
              {{b.number}}
            </span>
            <span  style="color:#7A8583">
              Embarcado: <b>{{ !b.landed ? 'Sim' : 'Não'}}</b>
            </span>
          </div>
        </q-card>
      </q-list>
    </div>
  </div>
</template>

<script>
import { cityToCamelCase, formatDate } from "../functions";
import { mutations, store } from "../store";

export default {
  name: "DetailTicket",
  filters: {
    formatDate,

    lowerCase(text) {
      if (!text) {
        return text;
      }

      return text.toLowerCase();
    }
  },
  computed: {
    ticket: {
      get () {
        return store.ticketDetails
      }
    }
  },
  mounted() {
    mutations.setHeaderTitle("DETALHES");
  },
  data() {
    return {
     
    };
  },
  methods: {
      cityToCamelCase,

  },
};
</script>

<style lang="scss" scoped>
.manual {
  background: #e5e5e5;
}

.manual__info {
  background-color: #ffffff;
  padding: 20px;
}

.info__passenger-baby {
  display: grid;

  padding: 10px 0;
  width: 80%;
  margin: auto;

  .passenger__name,
  .passenger__document {
    font-size: 16px;
    line-height: normal;
    text-transform: capitalize;

    margin: 0;
  }

  .passenger__name {
    color: #040006;
    font-weight: 600;
  }

  .passenger__type {
    font-size: 16px;
    line-height: 1.3;
    margin: 0;
    color: #040006;
    font-weight: 500;
  }

  .passenger__document {
    color: #23c400;
  }

  .document--highlight {
    font-weight: 600;
  }
}

.baby-checkbox {
  transform: scale(1);
  animation: colorchange 2s infinite;
}

@keyframes colorchange {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  }
}

.manual__buttons {
  display: grid;
  grid-template-columns: 1fr 1fr;

  width: 100%;
  height: 60px;

  .buttons__back,
  .buttons__handler {
    background-color: #ffffff;
    border-radius: unset;
    font-size: 15px;
  }

  .buttons__back {
    color: #b30c00;
    border-right: #ecedf3 solid 1px;
    font-weight: 600;
  }

  .buttons__handler--confirm {
    color: #20c600;
  }

  .buttons__handler--cancel {
    color: #b30c00;
  }
}

.luggage {
  background: #e5e5e5;
  padding: 20px;
  height: 80vh;

  .luggage__grid {
    display: grid;
    grid-template-columns: max-content 1fr max-content;
    padding: 20px;
    gap: 10px;
  }
}
</style>
